import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";

import { $isAuthenticated } from "../../internal/authenication";
import {
	$error,
	$redeemInviteToken,
	$redeemStatus,
	$responseResult,
} from "../../internal/redeem/redeem.atom";

export const useRedeemInvite = (inviteToken: string) => {
	const setRedeem = useSetAtom($redeemInviteToken);
	const redeemStatus = useAtomValue($redeemStatus);
	const error = useAtomValue($error);
	const responseResult = useAtomValue($responseResult);
	const isAuthenticated = useAtomValue($isAuthenticated);

	const callback = useCallback(
		(inviteToken: string) => {
			void setRedeem(inviteToken);
		},
		[setRedeem]
	);

	useEffect(() => {
		void callback(inviteToken);
	}, [isAuthenticated, callback, inviteToken]);

	return {
		retry: callback,
		redeemStatus,
		error,
		responseResult,
	};
};
